<div class="screen-container">
  <div *ngIf="!isSummary; else summaryBlock">
    <app-card
      [title]="'realEstate.title' | translate"
      [currentStep]="flowService.currentQuestionIndex"
      [steps]="flowService.questionsLength"
    >
      <div left-content>
        <ng-template [ngTemplateOutlet]="realEstateBlock"></ng-template>
        <div actions class="navigationButtons">
          <button
            (click)="handleNextButtonClick()"
            mat-flat-button
            color="primary"
          >
            {{ "accountData.nextButtonText" | translate }}
          </button>
          <button
            (click)="handleBackButtonClick()"
            mat-flat-button
            color="secondary"
          >
            {{ "accountData.backButtonText" | translate }}
          </button>
        </div>
      </div>
      <div right-content>
        <app-contact></app-contact>
      </div>
    </app-card>
  </div>

  <ng-template #summaryBlock>
    <div class="summary">
      <ng-template [ngTemplateOutlet]="realEstateBlock"></ng-template>
    </div>
  </ng-template>
</div>

<ng-template #realEstateBlock>
  <form [formGroup]="realEstateForm">
    <div left-content class="content-container">
      <app-radio [control]="realEstate" [options]="options"></app-radio>

      <div *ngIf="realEstate.value === 1">
        <app-textarea
          [control]="propertyDescription"
          [label]="'realEstate.propertyDescription'"
          (blurEvent)="propertyDescriptionUpdate()"
        ></app-textarea>
        <app-file-uploader
          [label]="'realEstate.propertyOptional'"
          [control]="realEstateFiles"
          [controlName]="'realEstateFiles'"
          [applicationId]="applicationId"
          [uploaderName]="assetName.REAL_ESTATE"
          [uploadedFileLabel]="'realEstate.uploadedFileLabel'"
          [isSummary]="isSummary"
        ></app-file-uploader>
      </div>
      <div class="infobox-container">
        <app-infobox
          [title]="'realEstate.infobox.title' | translate"
          [content]="'realEstate.infobox.content' | translate"
        >
        </app-infobox>
      </div>
    </div>
  </form>
</ng-template>
